/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
export enum AppType {
  parent = "parent",
  child = "child",
}
